<template>
  <div>
    <el-form ref="form" :rules="formRules" :inline="true" :model="form" label-width="80px">
      <div v-for="(item, index) in form.dynamicItem" :key="index">
        <el-form-item
          label="姓名"
          :prop="'dynamicItem.' + index + '.name'"
          :rules="{
            required: true, message: '姓名不能为空', trigger: 'blur'
        }"
        >
          <el-input v-model="item.name"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号"
          :prop="'dynamicItem.' + index + '.phone'"
          :rules="[
             {required: true, message: '手机号不能为空', trigger: 'blur'},
              { pattern: /^1[34578]\d{9}$/, message: '目前只支持中国大陆的手机号码' }
          ]"
        >
          <el-input v-model="item.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="index+1 == form.dynamicItem.length" @click="addItem" type="primary">增加</el-button>
          <el-button v-if="index !== 0" @click="deleteItem(item, index)" type="danger">删除</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        dynamicItem: [
          {
            name: "",
            phone: ""
          }
        ]
      }
    };
  },

  methods: {
    // Tooltip 文字提示
    addItem() {
      this.form.dynamicItem.push({
        name: "",
        phone: ""
      });
    },
    sure(form) {
      console.log(this.form.dynamicItem.length, "length");
      this.$refs[form].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteItem(item, index) {
      this.form.dynamicItem.splice(index, 1);
      console.log(this.form.dynamicItem, "删除");
    }
  }
};
</script>
<style scoped>
.everyDay {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: #409eff;
  color: #fff;
  border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/view/teram.vue